import { CSSObject } from '@emotion/react'
import { fonts, fontWeights, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const sectionOptionsWrapper: CSSObject = {
  backgroundColor: 'white',
  fontFamily: fonts.proxima,
  maxHeight: '396px',
  minHeight: '179px',
  padding: '2px',
  textAlign: 'left',
  width: '326px',
}

const sectionOptionsWrapperInterior: CSSObject = {
  maxHeight: '284px',
  overflowX: 'hidden',
  overflowY: 'scroll',
  padding: '0 12px 24px 12px',
}

const title: CSSObject = {
  alignItems: 'center',
  borderBottom: `2px solid ${colors.n9.base}`,
  color: colors.n3.base,
  display: 'flex',
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.bold,
  justifyContent: 'space-between',
  padding: '11px 8px 11px 12px',
  position: 'relative',
  textTransform: 'uppercase',
  zIndex: 2,
  '.kuiper-icon-wrapper': {
    color: colors.n7.base,
    cursor: 'pointer',
    '&:hover': {
      color: colors.n3.base,
    },
  },
}

const flexRow: CSSObject = {
  display: 'flex',
}

const sectionOption: CSSObject = {
  padding: '20px 10px 0 0',
}

const groupHeader: CSSObject = {
  color: colors.n4.base,
  font: fonts.proxima,
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bold,
  margin: '20px 12px 14px 0',
}

const groupSectionOption: CSSObject = {
  paddingRight: '8px',
  width: '95px',
}

const optionTitle: CSSObject = {
  alignItems: 'baseline',
  color: colors.n5.base,
  display: 'flex',
  fontSize: fontSizes.xxSmall,
  fontWeight: fontWeights.bold,
  textTransform: 'uppercase',
}

const getOptionStyling = (type: string, isValid: boolean): CSSObject => ({
  marginTop: '7px',
  width: type === 'number' ? '136px' : '281px',
  '.kuiper-modular-section-option': {
    '.kuiper-input-container': {
      border: isValid
        ? `1px solid ${colors.n9.base}`
        : `1px solid ${colors.red.base}`,
    },
    'input[type="number"]': {
      marginTop: '-5px',
      width: '132px',
    },
    'input[type="text"]': {
      paddingBottom: '10px',
    },
    '.kuiper-select-trigger.kuiper-light': {
      border: `1px solid ${colors.n9.base}`,
      width: '136px',
      backgroundColor: colors.n9.base,
    },
  },
})

const getGroupOptionStyling = (type: string): CSSObject => ({
  marginTop: '7px',
  width: type === 'number' ? '136px' : '281px',
  '.kuiper-modular-section-option': {
    '.kuiper-select-trigger.kuiper-light': {
      backgroundColor: colors.n9.base,
      border: `1px solid ${colors.n9.base}`,
      paddingRight: '8px',
      width: '95px',
    },
  },
})

const footerWrapper: CSSObject = {
  backgroundColor: colors.n10.base,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '6px',
  '.kuiper-modular-section-options-delete-section': {
    backgroundColor: colors.red.base,
    color: colors.red.darkest,
    '&:hover': {
      backgroundColor: colors.red.dark,
    },
    '&:active': {
      backgroundColor: colors.red.darker,
    },
    '&.kuiper-disabled': {
      backgroundColor: colors.n10.base,
      color: '#1010104D',
    },
  },
}

const warning: CSSObject = {
  backgroundColor: colors.orange.base,
  borderRadius: '10px',
  height: '8px',
  marginLeft: '10px',
  width: '8px',
}

const errorText: CSSObject = {
  color: colors.red.base,
  fontSize: fontSizes.small,
  paddingTop: '5px',
  width: '350px',
}

const styles = {
  errorText,
  flexRow,
  footerWrapper,
  getGroupOptionStyling,
  getOptionStyling,
  groupHeader,
  groupSectionOption,
  optionTitle,
  sectionOption,
  sectionOptionsWrapper,
  sectionOptionsWrapperInterior,
  title,
  warning,
}

export { styles }
